import { lazy } from 'react';

import { getConfig } from '@/features/environment/config';

import { adminRoutes } from './routes/admin-routes';
import { coverageRequestRoutes } from './routes/coverage-request-routes';
import { drpRoutes } from './routes/drp-routes';
import { educationRoutes } from './routes/education-routes';
import { ErrorBoundary } from './routes/error-boundary';
import { lgmRoutes } from './routes/lgm-routes';
import { lrpPriceEvolutionAnalysis, lrpPriceTrends, lrpRoutes } from './routes/lrp-routes';
import { managementReportsRoutes } from './routes/management-reports-routes';
import { miscRoutes, whatsNew } from './routes/misc-routes';

import type { RouteObject } from 'react-router-dom';

const AppLayout = lazy(() => import('@/features/AppLayout').then(m => ({ default: m.AppLayout })));

const routesChildren: RouteObject[] = [
  ...miscRoutes,
  adminRoutes,
  lgmRoutes,
  lrpRoutes,
  ...coverageRequestRoutes,
  educationRoutes,
  managementReportsRoutes,
  drpRoutes
];

// Tenant filtering stays centralized here — domain route files never read config.
const LEAP_EXCLUDED_ROUTES = new Set<RouteObject>([
  educationRoutes,
  managementReportsRoutes,
  drpRoutes,
  whatsNew,
  lrpPriceTrends,
  lrpPriceEvolutionAnalysis
]);

const pruneExcludedRoutes = (routeList: RouteObject[]): RouteObject[] =>
  routeList
    .filter(route => !LEAP_EXCLUDED_ROUTES.has(route))
    .map(route =>
      route.children ? { ...route, children: pruneExcludedRoutes(route.children) } : route
    );

const children =
  getConfig()?.CLIENT_NAME === 'lia-leap' ? pruneExcludedRoutes(routesChildren) : routesChildren;

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppLayout routes={children} />,
    errorElement: <ErrorBoundary />,
    children
  }
];
